import { useSelector } from 'react-redux';

export const useGetCountry = () => {
  const practice = useSelector((state: any) => state.login?.user?.practice);
  return practice?.country;
};
